import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'

const uris: any = {
	local: 'http://localhost/graphql',
	development: 'https://api-maps.360tourist.com/graphql',
	production: 'https://api-maps.360tourist.com/graphql',
}
const index =
	window.location.hostname === 'localhost'
		? 'local'
		: window.location.hostname === 'dev.360tourist.com'
		? 'development'
		: 'production'

const cache = new InMemoryCache()
const link = new HttpLink({
	credentials: 'include',
	uri: uris[index],
})
const client = new ApolloClient({
	cache,
	link,
})

export default client
